import type from './constants';

export default {
    saveParams: (params) => {
        return {
            type: type.SAVE_PARAMS,
            params,
        }
    },
    saveSearchParams: (params) => {
        return {
            type: type.SAVE_SEARCHPARAMS,
            params,
        }
    }
};


// WEBPACK FOOTER //
// ./src/components/homePage/afficheNews/store/actions.js